/* ARCHADIA — homepage motion layer (additive). See an-motion.css. */
(function () {
  'use strict';
  if (window.__anmInit) return;
  window.__anmInit = 1;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var d = document;
  var fine = window.matchMedia && window.matchMedia('(hover:hover) and (pointer:fine)').matches;

  function $$(sel, root) { return Array.prototype.slice.call((root || d).querySelectorAll(sel)); }
  function clamp(v, a, b) { return v < a ? a : (v > b ? b : v); }

  function init() {
    var vh = window.innerHeight;

    /* ---- Scroll progress bar ---- */
    var bar = d.createElement('div');
    bar.className = 'anm-progress';
    bar.setAttribute('aria-hidden', 'true');
    d.body.appendChild(bar);

    /* ---- Hero: scroll cue + content fades away as you scroll ---- */
    var hero = d.querySelector('.hero');
    var heroContent = hero && hero.querySelector('.hero__content');
    var cue = null;
    if (hero) {
      cue = d.createElement('div');
      cue.className = 'anm-cue';
      cue.setAttribute('aria-hidden', 'true');
      cue.innerHTML = '<span>Scroll</span><i></i>';
      hero.appendChild(cue);
    }

    /* ---- Custom order banner parallax ---- */
    var cob = d.querySelector('.cob-link');
    var cobMedia = cob && cob.querySelector('.cob-media');

    var ticking = false;
    function frame() {
      ticking = false;
      var y = window.scrollY || window.pageYOffset || 0;
      var wh = window.innerHeight;
      var max = d.documentElement.scrollHeight - wh;
      bar.style.transform = 'scaleX(' + (max > 0 ? clamp(y / max, 0, 1) : 0).toFixed(4) + ')';
      if (hero && heroContent) {
        var hh = hero.offsetHeight || wh;
        if (y < hh) {
          var p = clamp(y / (hh * 0.75), 0, 1);
          heroContent.style.opacity = (1 - p).toFixed(3);
          heroContent.style.transform = 'translate3d(0,' + (-p * 48).toFixed(1) + 'px,0)';
        }
        if (cue) cue.classList.toggle('is-gone', y > 40);
      }
      if (cobMedia) {
        var r = cob.getBoundingClientRect();
        if (r.bottom > 0 && r.top < wh) {
          var q = (r.top + r.height / 2 - wh / 2) / (wh / 2 + r.height / 2);
          cobMedia.style.transform = 'translate3d(0,' + (q * -7).toFixed(2) + '%,0) scale(1.16)';
        }
      }
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    frame();

    /* ---- Headings: split into words that rise ---- */
    $$('.section-head h2, .dotw-title, .mof-title').forEach(function (h) {
      if (h.children.length || h.classList.contains('anm-split')) return;
      var words = h.textContent.split(' ').filter(function (w) { return w.trim() !== ''; });
      if (!words.length) return;
      h.textContent = '';
      words.forEach(function (w, i) {
        var outer = d.createElement('span');
        outer.className = 'anm-w';
        var inner = d.createElement('span');
        inner.style.setProperty('--i', i);
        inner.textContent = w.trim();
        outer.appendChild(inner);
        h.appendChild(outer);
        if (i < words.length - 1) h.appendChild(d.createTextNode(' '));
      });
      h.classList.add('anm-split');
    });

    /* ---- Scroll-in for sections that had no entrance animation ---- */
    var io = null;
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var el = en.target;
          io.unobserve(el);
          el.classList.add('anm-in', 'anm-seen');
          var i = parseInt(el.style.getPropertyValue('--i') || '0', 10) || 0;
          setTimeout(function () { el.classList.remove('anm-prep', 'anm-in'); }, 1700 + i * 110);
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -6% 0px' });
    }
    function prep(el, i) {
      if (!io || el.getBoundingClientRect().top < vh * 0.92) { el.classList.add('anm-seen'); return; }
      el.style.setProperty('--i', i);
      el.classList.add('anm-prep');
      io.observe(el);
    }
    $$('.mof-header, .mof-video-wrap').forEach(function (el) { prep(el, 0); });
    $$('.mof-step').forEach(function (el, i) { prep(el, i % 4); });
    $$('.cob-content > *').forEach(function (el, i) { prep(el, i); });

    /* ---- Deal countdown: digits tick ---- */
    var timer = d.querySelector('[data-dotw-timer]');
    if (timer && 'MutationObserver' in window) {
      var nums = $$('.dotw-num', timer);
      nums.forEach(function (n) { n.__anmV = n.textContent; });
      new MutationObserver(function () {
        nums.forEach(function (n) {
          var v = n.textContent;
          if (v === n.__anmV) return;
          n.__anmV = v;
          if (n.animate) n.animate([{ transform: 'translateY(-38%)', opacity: 0.15 }, { transform: 'none', opacity: 1 }], { duration: 320, easing: 'cubic-bezier(.22,1,.36,1)' });
        });
      }).observe(timer, { childList: true, characterData: true, subtree: true });
    }

    /* ---- Click ripple on buttons (all devices) ---- */
    d.addEventListener('pointerdown', function (e) {
      var b = e.target && e.target.closest && e.target.closest('.btn');
      if (!b) return;
      var r = b.getBoundingClientRect();
      var s = Math.max(r.width, r.height) * 2;
      var sp = d.createElement('span');
      sp.className = 'anm-ripple';
      sp.setAttribute('aria-hidden', 'true');
      sp.style.width = sp.style.height = s + 'px';
      sp.style.left = (e.clientX - r.left - s / 2) + 'px';
      sp.style.top = (e.clientY - r.top - s / 2) + 'px';
      b.appendChild(sp);
      setTimeout(function () { if (sp.parentNode) sp.parentNode.removeChild(sp); }, 650);
    }, { passive: true });

    if (!fine) return;

    /* ---- Desktop: 3D tilt on cards and tiles, magnetic buttons ---- */
    var cur = null, curBtn = null, pending = null, raf = 0;
    function resetTilt() {
      if (!cur) return;
      var el = cur;
      cur = null;
      el.style.transform = '';
      setTimeout(function () { if (el !== cur) el.classList.remove('anm-tilt'); }, 220);
    }
    function resetBtn() {
      if (!curBtn) return;
      curBtn.style.transform = '';
      curBtn = null;
    }
    function move() {
      raf = 0;
      var e = pending;
      if (!e || !e.target || !e.target.closest) return;
      var host = e.target.closest('.card, .col-tile');
      var el = null;
      if (host) {
        if (host.classList.contains('col-tile')) {
          var par = host.parentElement;
          el = (par && par.classList.contains('reveal-stagger') && !par.classList.contains('is-in')) ? null : host;
        } else {
          el = host.querySelector('.card__media');
        }
      }
      if (el !== cur) {
        resetTilt();
        cur = el;
        if (el) el.classList.add('anm-tilt');
      }
      if (el) {
        var r = el.getBoundingClientRect();
        var px = clamp((e.clientX - r.left) / r.width, 0, 1);
        var py = clamp((e.clientY - r.top) / r.height, 0, 1);
        el.style.transform = 'perspective(900px) rotateX(' + ((0.5 - py) * 8).toFixed(2) + 'deg) rotateY(' + ((px - 0.5) * 10).toFixed(2) + 'deg)';
        el.style.setProperty('--anm-gx', (px * 100).toFixed(1) + '%');
        el.style.setProperty('--anm-gy', (py * 100).toFixed(1) + '%');
      }
      var b = e.target.closest('.btn');
      if (b && b.closest('.cart-drawer')) b = null;
      if (b !== curBtn) { resetBtn(); curBtn = b; }
      if (b) {
        var br = b.getBoundingClientRect();
        b.style.transform = 'translate3d(' + ((e.clientX - br.left - br.width / 2) * 0.18).toFixed(1) + 'px,' + ((e.clientY - br.top - br.height / 2) * 0.3 - 2).toFixed(1) + 'px,0)';
      }
    }
    d.addEventListener('pointermove', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      pending = e;
      if (!raf) raf = requestAnimationFrame(move);
    }, { passive: true });
    d.documentElement.addEventListener('mouseleave', function () { resetTilt(); resetBtn(); });

    /* ---- Desktop: drag product rows with the mouse ---- */
    $$('.carousel').forEach(function (c) {
      var down = false, moved = false, sx = 0, sl = 0;
      c.addEventListener('mousedown', function (e) {
        if (e.button !== 0) return;
        down = true; moved = false; sx = e.pageX; sl = c.scrollLeft;
      });
      window.addEventListener('mousemove', function (e) {
        if (!down) return;
        var dx = e.pageX - sx;
        if (!moved && Math.abs(dx) > 6) { moved = true; c.classList.add('anm-drag'); resetTilt(); }
        if (moved) c.scrollLeft = sl - dx;
      });
      window.addEventListener('mouseup', function () {
        if (!down) return;
        down = false;
        if (moved) setTimeout(function () { c.classList.remove('anm-drag'); moved = false; }, 0);
      });
      c.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); }
      }, true);
      c.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init);
  else init();
})();
